import { RouteProps } from "react-router-dom";

// import pages (modules)
import LogoutPage from "./LogoutPage";
import CallbackPage from "./CallbackPage";
import SilentRenewPage from "./SilentRenewPage";

const loginRoutes: RouteProps[] = [
  { exact: true, path: "/logout", component: LogoutPage },
  { exact: true, path: "/callback", component: CallbackPage },
  { exact: true, path: "/silent_renew", component: SilentRenewPage },
];

export default loginRoutes;
